// extracted by mini-css-extract-plugin
module.exports = {"product":"Product_product__3FltH","back":"Product_back__232-I"};